import styles from "./PagedSection.module.css";
import ArrowSVG from "../SVGs/ArrowSVG";

function PagedSection({
    currentPage,
    setCurrentPage,
    total,
    children,
    perPage,
    setPerPage,
    className,
}) {
    const realPerPage = Number(perPage) === -1 ? total : perPage;
    const totalPages = Math.ceil(total / realPerPage);

    function handleChangeOption(event) {
        setPerPage(Number(event.target.value));
        setCurrentPage(1);
    }
    return (
        <section id={styles.section} className={className}>
            {children}
            <div id={styles.controls}>
                <div id={styles.top_controls}>
                    <button
                        className={styles.arrow_button}
                        id={styles.left}
                        style={{
                            visibility:
                                currentPage === 1 ? "hidden" : "visible",
                        }}
                        onClick={() =>
                            setCurrentPage((prev) => Math.max(0, prev - 1))
                        }
                    >
                        <ArrowSVG
                            style={{
                                width: 16,
                                rotate: "180deg",
                            }}
                        />
                    </button>
                    {Array(totalPages)
                        .fill(0)
                        .map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentPage(index + 1)}
                                className={[
                                    styles.number_button,
                                    Number(currentPage) === index + 1
                                        ? styles.active
                                        : "",
                                ].join(" ")}
                            >
                                {index + 1}
                            </button>
                        ))}
                    <button
                        className={styles.arrow_button}
                        id={styles.right}
                        style={{
                            visibility:
                                currentPage === totalPages
                                    ? "hidden"
                                    : "visible",
                        }}
                        onClick={() =>
                            setCurrentPage((prev) =>
                                Math.min(prev + 1, totalPages)
                            )
                        }
                    >
                        <ArrowSVG
                            style={{
                                width: 16,
                            }}
                        />
                    </button>
                </div>
                {/* <div id={styles.bottom_controls}> */}
                <p>
                    {`Showing ${
                        (currentPage - 1) * Number(perPage) + 1
                    } - ${Math.min(
                        currentPage * realPerPage,
                        total
                    )} of ${total} results`}
                </p>
                <div>
                    <select
                        name="perPage"
                        id={styles.perPage}
                        onChange={handleChangeOption}
                        value={perPage}
                    >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        {/* <option value="-1">All</option> */}
                    </select>{" "}
                    results per page
                </div>
            </div>
        </section>
    );
}

export default PagedSection;
